export default __webpack_public_path__ + "static/media/icon-card-mx-flight-month-limit.11d982f7.svg";